import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';
import styled from 'styled-components';

const styles = `
  font-size: ${px2rem(12)};
  position: absolute;
  right: ${px2rem(10)};
  top: ${px2rem(10)};
`;

export default buildStyledComponent(
  'RecipientCountWrapper',
  styled.div,
  styles,
);



// WEBPACK FOOTER //
// ./compositions/NotesWidget/NoteCreator/RecipientCount/Wrapper.js